import React from "react";

const SearchResultEmpty = () => {
    return (
        <React.Fragment>
            <div></div>
        </React.Fragment>
    )
}

export default SearchResultEmpty;